import { VEHICLE_INFORMATION_OBJECT } from 'store/enums';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  loader: false,
  vehicleInformation: VEHICLE_INFORMATION_OBJECT,
  images: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
